module.exports = __webpack_public_path__ + "img/V81.cb3dc4cd.jpg";